import { render, staticRenderFns } from "./MenuEsquerdo.vue?vue&type=template&id=0272b144&scoped=true"
import script from "./MenuEsquerdo.vue?vue&type=script&lang=js"
export * from "./MenuEsquerdo.vue?vue&type=script&lang=js"
import style0 from "./MenuEsquerdo.vue?vue&type=style&index=0&id=0272b144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0272b144",
  null
  
)

export default component.exports